{
  "search": "Søg",
  "searchWithin": "Søg i"
}
